import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OpenAccountButton.module.css';

interface OpenAccountButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
}

export const OpenAccountButton: React.FC<OpenAccountButtonProps> = ({
  className = '',
  variant = 'secondary',
  size = 'medium',
  onClick
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open('https://pay.gcbusiness.space/site/home', '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${styles.openAccountButton} ${styles[variant]} ${styles[size]} ${className}`}
    >
      {t('nav.openAccount')}
    </button>
  );
};
